// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "ridea/npm/js/" + {"129":"e5e20cf6ef180d1d","314":"a00acbb121432d42","1444":"616502b082510edf","2749":"28c9ed89a7b26ce3","2855":"0ce95ced727a57d5","3113":"94c9706b4395467a","4202":"c8852b1531f06461","5122":"c7f606f2898bcbfe","5981":"677bb7c426e829c3","7977":"e49a241de96fefd3","8122":"3dc66cd99161e5ee"}[chunkId] + ".js";
};